import { render, staticRenderFns } from "./ContentSkeleton.vue?vue&type=template&id=43104340&scoped=true&"
import script from "./ContentSkeleton.vue?vue&type=script&lang=js&"
export * from "./ContentSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ContentSkeleton.vue?vue&type=style&index=0&id=43104340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43104340",
  null
  
)

export default component.exports